import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { REQUESTS_ROLES } from '@routes';
import { EytcAuthService } from '@services/index';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { LinkColumnComponent } from '../link-column/link-column.component';

@Component({
  selector: 'app-item-id-column',
  standalone: true,
  imports: [LinkColumnComponent],
  templateUrl: './item-id-column.component.html',
  styleUrl: './item-id-column.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemIdColumnComponent implements AgRendererComponent {
  readonly #eytcAuth = inject(EytcAuthService);
  readonly #roles = this.#eytcAuth.userRoles();

  readonly requestEntityId = signal<string>('');
  readonly requestId = signal<string>('');
  readonly itemEntityId = signal<string>('');
  readonly itemId = signal<string>('');
  readonly label = signal<string | null>('');
  readonly origin = signal<ItemIdLinkOrigin>(ItemIdLinkOrigin.ItemsGrid);

  readonly routerLink = computed(() => {
    switch (this.origin()) {
      case ItemIdLinkOrigin.ItemsGrid:
        return [this.itemEntityId(), this.itemId()];
      case ItemIdLinkOrigin.PendingItemsGrid:
        return ['items', this.itemEntityId(), this.itemId()];
      case ItemIdLinkOrigin.DisputeItemsGrid:
        return ['items', this.itemEntityId(), this.itemId()];
      default:
        return [];
    }
  });

  readonly canAccessItemDetails = computed(() => {
    return this.#roles.some(role => REQUESTS_ROLES.includes(role));
  });

  agInit(params: ICellRendererParams): void {
    this.origin.set(
      (params as ICellRendererParams & { origin?: ItemIdLinkOrigin }).origin ?? ItemIdLinkOrigin.ItemsGrid
    );
    this.requestEntityId.set(params.data.requestEntityId);
    this.requestId.set(params.data.requestId);
    this.itemEntityId.set(params.data.itemEntityId);
    this.itemId.set(params.data.itemId);
    this.label.set(params.data.itemEntityId ? params.data.itemId : null);
  }

  refresh(params: ICellRendererParams): boolean {
    this.agInit(params);
    return true;
  }
}

export enum ItemIdLinkOrigin {
  ItemsGrid,
  PendingItemsGrid,
  DisputeItemsGrid,
}
